(function () {
  'use strict';
  function initialise(scope) {
    scope.querySelectorAll('[data-mas-aquatic]').forEach(function (root) {
      if (root.dataset.aquaticReady) return;
      root.dataset.aquaticReady = 'true';
      var categories = root.querySelector('[data-aquatic-categories]');
      var toggle = root.querySelector('[data-aquatic-all-types]');
      if (toggle && categories) {
        categories.id = toggle.getAttribute('aria-controls');
        categories.dataset.ready = 'true';
        categories.dataset.currentMore = String(!!categories.querySelector('.mas-aquatic__category--more.is-current'));
        toggle.hidden = categories.querySelectorAll('a').length <= 3;
        toggle.addEventListener('click', function () {
          var expanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(expanded));
          categories.dataset.expanded = String(expanded);
          toggle.querySelector('[data-types-label]').textContent = expanded ? 'Show less' : 'All types';
        });
      }
      var rail = root.querySelector('[data-aquatic-rail]');
      var controls = root.querySelector('[data-aquatic-rail-controls]');
      if (rail && controls) {
        var previous = controls.querySelector('[data-aquatic-previous]');
        var next = controls.querySelector('[data-aquatic-next]');
        var desktop = window.matchMedia('(min-width: 768px)');
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var updateRail = function () {
          // Allow for the rail's focus-ring padding when scroll-snap settles.
          previous.disabled = rail.scrollLeft <= 8;
          next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
        };
        var revealCurrent = function () {
          if (desktop.matches) {
            var current = rail.querySelector('.mas-aquatic__category.is-current');
            if (current) {
              var currentBox = current.getBoundingClientRect();
              var railBox = rail.getBoundingClientRect();
              rail.scrollLeft += currentBox.left - railBox.left - (rail.clientWidth - currentBox.width) / 2;
            }
          } else {
            rail.scrollLeft = 0;
          }
          updateRail();
        };
        controls.hidden = false;
        previous.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * .8, behavior: reducedMotion.matches ? 'auto' : 'smooth' }); });
        next.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * .8, behavior: reducedMotion.matches ? 'auto' : 'smooth' }); });
        rail.addEventListener('scroll', updateRail, { passive: true });
        desktop.addEventListener('change', revealCurrent);
        if ('ResizeObserver' in window) new ResizeObserver(updateRail).observe(rail);
        revealCurrent();
      }
      var form = root.querySelector('[data-aquatic-filters]');
      if (!form) return;
      form.querySelectorAll('[data-aquatic-autosubmit]').forEach(function (input) {
        input.addEventListener('change', function () { form.requestSubmit(); });
      });
      form.addEventListener('submit', function () {
        // Empty price fields must not become an unintended zero-price filter.
        form.querySelectorAll('input[type="number"]').forEach(function (input) { input.disabled = input.value === ''; });
      });
      root.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var open = form.querySelector('details[open]');
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      });
      document.addEventListener('click', function (event) {
        form.querySelectorAll('details[open]').forEach(function (details) {
          if (!details.contains(event.target)) details.open = false;
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialise(document); }, { once: true });
  else initialise(document);
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
}());
